import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, unref as _unref, normalizeClass as _normalizeClass, withCtx as _withCtx, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "px-6 md:px-8 pt-6 pb-20" }
const _hoisted_2 = { class: "max-w-[1040px]" }
const _hoisted_3 = { class: "flex items-center gap-3 mb-2" }
const _hoisted_4 = ["disabled"]

import { computed, onMounted, reactive, ref } from 'vue'
import { ColorPicker } from 'vue-accessible-color-picker'
import { useStore } from 'vuex'

import ImageUploaderNeue from '@/components/neue/ImageUploaderNeue.vue'
import InputField from '@/components/neue/InputField.vue'
import NeueLoading from '@/components/neue/NeueLoading.vue'
import SettingsSection from '@/components/neue/SettingsSection.vue'
import DomainsSection from '@/components/storefront/DomainsSection.vue'
import privilegeService from '@/services/privilege.service'
import api from '@/store/api'
import { mapRelationship } from '@/store/mappers'


export default {
  __name: 'StorePrefs',
  setup(__props) {

const store = useStore()

const canUpdateSite = computed(() => privilegeService.canAccessResourceAction('site', null, 'update'))

const user = computed(() => mapRelationship({ type: 'user', id: store.getters.loggedInUserId }))

const loading = ref(true)
const hasUnsavedChanges = ref(false)
const logoUploaderKey = ref(0)

const local = reactive({
  name: '',
  head: '',
  meta: '',
  capi: '',
  profile: null,
  banner: null,
  color: '',
  clickUrl: ''
})

const profile = computed(() => mapRelationship(user.value?.relationships.profile_picture.data))

const markUnsaved = () => {
  if (canUpdateSite.value) hasUnsavedChanges.value = true
}

const changeLogo = attachment => {
  local.profile = attachment
  markUnsaved()
}

const opaqueHex = hex =>
  (hex || '')
    .toLowerCase()
    .replace(/^(#[0-9a-f]{6})ff$/, '$1')
    .replace(/^(#[0-9a-f]{3})f$/, '$1')

const changeColor = e => {
  if (!canUpdateSite.value) return
  if (opaqueHex(local.color) === opaqueHex(e.colors.hex)) return
  local.color = e.colors.hex
  markUnsaved()
}

const setLocal = () => {
  hasUnsavedChanges.value = false
  logoUploaderKey.value += 1
  local.name = user.value.attributes.user_name
  local.head = user.value.attributes.html_head_content
  local.meta = user.value.attributes.facebook_pixel_container_id
  local.capi = user.value.attributes.facebook_capi_token
  local.profile = null
  local.banner = null
  local.color = user.value.attributes.color.hex ? `#${user.value.attributes.color.hex}` : ''
  local.clickUrl = profile.value?.attributes?.click_url
}

onMounted(() => {
  api
    .call('GET', `users/${store.getters.loggedInUserId}`)
    .then(setLocal)
    .finally(() => (loading.value = false))
})

const handleSubmit = () => {
  if (!canUpdateSite.value) return
  hasUnsavedChanges.value = false

  let profilePictureAttributes = {}

  if (local.profile) {
    profilePictureAttributes = local.profile
    if (local.clickUrl) {
      profilePictureAttributes.click_url = local.clickUrl
    } else {
      profilePictureAttributes.click_url = ''
    }
  } else if (profile.value && !local.clickUrl) {
    if (profile.value?.id) {
      profilePictureAttributes = {
        _id: profile.value.id,
        click_url: null
      }
    } else {
      profilePictureAttributes = profile.value || {}
    }
  } else if (!local.profile && profile.value?.id) {
    profilePictureAttributes = {
      _id: profile.value.id,
      click_url: local.clickUrl
    }
  }

  api.call('PUT', 'profile', {
    profile: {
      user_name: local.name,
      html_head_content: local.head,
      facebook_pixel_container_id: local.meta,
      facebook_capi_token: local.capi,
      profile_picture_attributes: profilePictureAttributes,
      banner_picture_attributes: local.banner,
      default_color: local.color
    }
  })
}

return (_ctx, _cache) => {
  const _component_SecondaryTop = _resolveComponent("SecondaryTop")
  const _component_SaveBar = _resolveComponent("SaveBar")
  const _component_SecondaryNav = _resolveComponent("SecondaryNav")

  return (_openBlock(), _createBlock(_component_SecondaryNav, null, {
    top: _withCtx(() => [
      _createVNode(_component_SecondaryTop, {
        text: "Storefront",
        "save-status": true
      }),
      (canUpdateSite.value)
        ? (_openBlock(), _createBlock(_component_SaveBar, {
            key: 0,
            "has-unsaved-changes": hasUnsavedChanges.value,
            onOnDiscard: setLocal,
            onOnSave: handleSubmit
          }, null, 8, ["has-unsaved-changes"]))
        : _createCommentVNode("", true)
    ]),
    main: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(NeueLoading, { loading: loading.value }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(SettingsSection, {
                title: "Business details",
                description: "How your business shows up for customers - in your storefront header, on receipts and in the emails they get from you."
              }, {
                default: _withCtx(() => [
                  _createVNode(InputField, {
                    modelValue: local.name,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((local.name) = $event)),
                    name: "Business name",
                    placeholder: "Your Business Name",
                    disabled: !canUpdateSite.value,
                    onInput: markUnsaved
                  }, null, 8, ["modelValue", "disabled"]),
                  _createElementVNode("div", null, [
                    _cache[5] || (_cache[5] = _createElementVNode("p", { class: "block text-sm font-medium text-gray-700 mb-1" }, "Business logo", -1)),
                    (_openBlock(), _createBlock(ImageUploaderNeue, {
                      key: logoUploaderKey.value,
                      files: profile.value?.attributes?.secure_url ? [profile.value] : [],
                      retained: true,
                      multiple: false,
                      editable: canUpdateSite.value,
                      onChange: changeLogo
                    }, null, 8, ["files", "editable"]))
                  ]),
                  (profile.value || local.profile)
                    ? (_openBlock(), _createBlock(InputField, {
                        key: 0,
                        modelValue: local.clickUrl,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((local.clickUrl) = $event)),
                        name: "Logo link",
                        description: "Customers who click your logo go to this web address, in a new tab.",
                        placeholder: "https://www.business-url.com",
                        disabled: !canUpdateSite.value,
                        onInput: markUnsaved
                      }, null, 8, ["modelValue", "disabled"]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_3, [
                      _cache[6] || (_cache[6] = _createElementVNode("p", { class: "text-sm font-medium text-gray-700" }, "Store color", -1)),
                      _createElementVNode("span", {
                        class: "h-5 w-10 rounded border border-gray-200",
                        style: _normalizeStyle({ backgroundColor: local.color }),
                        "aria-hidden": "true"
                      }, null, 4)
                    ]),
                    _createElementVNode("div", {
                      class: _normalizeClass(!canUpdateSite.value && 'pointer-events-none opacity-50')
                    }, [
                      _createVNode(_unref(ColorPicker), {
                        color: local.color,
                        "visible-formats": ['hex'],
                        "default-format": "hex",
                        "alpha-channel": "hide",
                        onColorChange: changeColor
                      }, null, 8, ["color"])
                    ], 2)
                  ])
                ]),
                _: 1
              }),
              _createVNode(SettingsSection, {
                title: "Tracking",
                description: "Connect analytics and ad tools to your storefront. A header tag is code added to every storefront page, like an analytics snippet. Your Meta pixel ID and Facebook CAPI token let Facebook match ad clicks to orders, so your ad results are more accurate."
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", {
                    class: _normalizeClass(!canUpdateSite.value && 'opacity-50 cursor-not-allowed')
                  }, [
                    _cache[7] || (_cache[7] = _createElementVNode("label", {
                      for: "storefront-header-tag",
                      class: "block text-sm font-medium text-gray-700 mb-1"
                    }, " Header tag ", -1)),
                    _withDirectives(_createElementVNode("textarea", {
                      id: "storefront-header-tag",
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ((local.head) = $event)),
                      disabled: !canUpdateSite.value,
                      rows: "5",
                      placeholder: "<script>/* code here */</script>",
                      class: _normalizeClass(["shadow-sm block w-full font-mono focus:ring-blue-500 focus:border-blue-500 sm:text-sm border border-gray-300 rounded-md placeholder:text-gray-400", !canUpdateSite.value && 'bg-gray-50 text-gray-500 cursor-not-allowed']),
                      onInput: markUnsaved
                    }, null, 42, _hoisted_4), [
                      [_vModelText, local.head]
                    ]),
                    _cache[8] || (_cache[8] = _createElementVNode("p", { class: "mt-2 text-sm text-gray-500" }, "Only paste code from a tool you trust.", -1))
                  ], 2),
                  _createVNode(InputField, {
                    modelValue: local.meta,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => ((local.meta) = $event)),
                    name: "Meta pixel ID",
                    placeholder: "12345XXXXXXXXXXX",
                    disabled: !canUpdateSite.value,
                    onInput: markUnsaved
                  }, null, 8, ["modelValue", "disabled"]),
                  _createVNode(InputField, {
                    modelValue: local.capi,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => ((local.capi) = $event)),
                    name: "Facebook CAPI token",
                    description: "Add your Facebook CAPI token to improve conversion tracking accuracy.",
                    placeholder: "Your Facebook CAPI token",
                    disabled: !canUpdateSite.value,
                    onInput: markUnsaved
                  }, null, 8, ["modelValue", "disabled"])
                ]),
                _: 1
              }),
              _createVNode(DomainsSection)
            ])
          ]),
          _: 1
        }, 8, ["loading"])
      ])
    ]),
    _: 1
  }))
}
}

}